import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "lds-ring absolute inset-0" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", {
        style: _normalizeStyle(_ctx.tick)
      }, null, 4),
      _createElementVNode("div", {
        style: _normalizeStyle(_ctx.tick)
      }, null, 4),
      _createElementVNode("div", {
        style: _normalizeStyle(_ctx.tick)
      }, null, 4),
      _createElementVNode("div", {
        style: _normalizeStyle(_ctx.tick)
      }, null, 4)
    ])
  ]))
}